import { ButtonLink, Container, moduleOrigins, SectionHeading, Slashes, Theme } from '@growup/ui';

const PERKS = [
  {
    index: '01',
    title: 'Eventos ao vivo',
    text: 'Transmite os torneios e os encontros da Grow uP, com lugar reservado na equipa de cada evento.',
  },
  {
    index: '02',
    title: 'Comunidade',
    text: 'Divulgação nas redes e no Discord da Grow uP, e uma equipa de streamers para fazer coisas em conjunto.',
  },
  {
    index: '03',
    title: 'O teu painel',
    text: 'Horas em direto, espectadores e seguidores dos últimos 30 dias, lidos da Twitch, num só sítio.',
  },
];

const STEPS = [
  'Entra com a tua conta Grow uP (ou cria uma no site).',
  'Liga a tua conta da Twitch à conta Grow uP, no site, em Redes.',
  'Preenche a candidatura. A equipa de streaming responde por email.',
];

/**
 * `/`: the program and how to join. The streamers themselves are shown on the
 * site (`growup.gg/streamers`); the portal is for the streamer team.
 */
export function Home() {
  return (
    <>
      <Theme name="red">
        <Container className="flex flex-col gap-8 py-16 sm:py-24">
          <Slashes />
          <SectionHeading
            level={1}
            size="xl"
            label="Stream Portal"
            title="Streamers Grow uP"
            lead="A equipa de criadores da Grow uP Esports. Transmitimos os nossos eventos, crescemos juntos e damos palco a quem joga."
          />
          <div className="flex flex-wrap gap-3">
            <ButtonLink href="/candidatura" variant="secondary" size="lg">
              Candidatar-me
            </ButtonLink>
            <ButtonLink href={`${moduleOrigins().site}/streamers`} variant="ghost" size="lg">
              Ver os streamers
            </ButtonLink>
          </div>
        </Container>
      </Theme>

      <Container className="flex flex-col gap-10 py-16">
        <SectionHeading label="O que tens" title="Mais do que um canal" />
        <ul className="grid gap-8 md:grid-cols-3">
          {PERKS.map((p) => (
            <li key={p.index} className="flex flex-col gap-3 border-t-2 border-gu-accent pt-4">
              <span className="font-display text-headline text-gu-accent">{p.index}</span>
              <h3 className="font-display text-title uppercase text-gu-ink">{p.title}</h3>
              <p className="text-body text-gu-ink-muted">{p.text}</p>
            </li>
          ))}
        </ul>
      </Container>

      <section className="border-y border-gu-line bg-gu-raised">
        <Container className="grid gap-8 py-16 md:grid-cols-2 md:items-center">
          <SectionHeading label="Como entrar" title="Três passos" />
          <ol className="flex flex-col gap-4">
            {STEPS.map((text, i) => (
              <li key={text} className="flex gap-4">
                <span className="font-display text-title text-gu-accent">{i + 1}</span>
                <span className="text-body text-gu-ink">{text}</span>
              </li>
            ))}
          </ol>
        </Container>
      </section>
    </>
  );
}
